import React, { Component } from 'react';
import {FooterSection, FooterDropDownSection, FooterLinkList, Footer} from 'react-mdl';
import {Link} from 'react-router-dom';
import logo from '../logo.svg';
export default class Foot extends Component {
    render() {
        return (
            <Footer size="mini" style={{backgroundColor:'var(--mainWhite)', color:'white',}}>
                <FooterSection type="left" style={{fontSize:'22px', margin:'auto'}}>
                    <FooterLinkList>
                    <div className="links-footer">
                        
                                <Link to="/products" className="links">
                
                                    <i className="fas fa-store" style ={{fontSize:'42px',color:'black'}}>
                                    </i>
                                </Link>
                                <p style={{color:'black', textAlign:'center'}}>Store</p>
                        </div>
                            <div className="links-footer">
                                <Link to="/cart" className="links">
                                    <i className="fas fa-cart-plus" style ={{fontSize:'42px',color:'black'}}>
                                    </i>
                                </Link>
                                <p style={{color:'black', textAlign:'center'}}>Cart</p>
                        </div>
                        <div className="links-footer">
                    <Link to="/" className="links"> <img src={logo} alt="logo"/> </Link>
                    <p style={{color:'black', textAlign:'center'}}>Home</p>
                        </div>
                        <div className="links-footer">
                    <a className="btn-lg"  href="https://www.facebook.com/cunhascountrystore/" >
                        <i class="fab fa-facebook-f" style ={{fontSize:'42px', color:'black'}}/>
                       </a>
                       <p style={{color:'black', textAlign:'center'}}>FaceBook</p>
                    </div>
                    <div className="links-footer">
                       <a className="btn-lg"  href="https://www.instagram.com/cunhascountrystore/" style ={{}}>
                        <i class="fab fa-instagram" style ={{fontSize:'42px',color:'black'}}/>
                           </a>  
                           <p style={{color:'black', textAlign:'center'}}>Instagram</p>
                            </div>
                            <div className="links-footer">
                        <Link to="/contact" className="links">
                        <i class = "fas fa-phone-alt" style={{fontSize:'42px',color:'black'}}>
                        </i>
                        </Link>
                        <p style={{color:'black', textAlign:'center'}}>Contact</p>
                        </div>
                        
                    </FooterLinkList>
                </FooterSection>
            </Footer>
        )};
}
